<template>
    <div class="orderView" v-if="show">
        <design :item = item></design>
        <orderInfo :item = item></orderInfo>
        <paymentInfo :item = item></paymentInfo>
        <commodityInfo :item = item></commodityInfo>
        <div class="getPayment">
            <div class="flex-row paymentItem m-r-53 sumPirce">
                <p>商品总价:</p>
                <p>￥{{item.commodityMoney}}</p>
            </div>
            <div class="flex-row paymentItem m-r-33 actualPrice">
                <p>实际付款:</p>
                <p class="fontColor">￥{{item.actualPayment}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import { Step, Steps } from 'vant';
import design from '@/components/design.vue';
import orderInfo from '@/components/orderInfo.vue';
import paymentInfo from '@/components/paymentInfo.vue';
import commodityInfo from '@/components/commodityInfo.vue';
import { getOrderDetail } from '@/api/index';
export default {
    components:{
        [Step.name] : Step,
        [Steps.name] : Steps,
        design,
        orderInfo,
        paymentInfo,
        commodityInfo
    },
    data(){
        return{
            item: {},
            show: false
        }
    },
    created(){
        this.getInfo();
    },
    methods:{
        getInfo(){
            getOrderDetail({orderId: this.$route.query.id, orderNode: 1}).then(res => {
                this.item = res.data;
                this.show = true;
            }).catch(error => {
                console.log('获取订单详情 views/order/orderDetails')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.orderView{
    background: $color-ed;
    width: 100vw;
    overflow: hidden;
    padding-bottom: 20px;
}
.heads{
    width: 100vw;
    padding:10px 0;
    background: $ffff; 
    overflow-x:scroll;
    .setepsList{
        width: 150%;
    }
}
.getPayment{
    width: 100%;
    background: $ffff;
    padding: 30px 0; 
    .paymentItem{
        justify-content: flex-end;
        margin-bottom: 26px;
    }
    .sumPirce{
        font-size: 24px;
        font-weight: 400;
        color: $color-102;
        line-height: 70px;
    }
}
.actualPrice{
    font-size: 28px;
    color: $color-51;
}
.fontColor{
    color: $color-36;
}
</style>

